import React from 'react'
import ReactDOM from 'react-dom'
import { injectGlobal } from 'styled-components'
import reset from 'styled-reset'
import { App } from './components'
import registerServiceWorker from './registerServiceWorker'

injectGlobal`
	${reset}

	html {
		font-size: 62.5%;
		overflow-y: scroll;
		height: 100%;
		box-sizing: border-box;
	}

	body, button, textarea {
		font-family: Ubuntu, Helvetica, Arial, sans-serif;
		font-size: 1.6rem;
		position: relative;
		outline: none;
		margin: 0;
		min-height: 100%;
		line-height: 1.08;
	}

	strong {
		font-weight: 600;
	}

	em {
		font-style: italic;
	}

	a {
		text-decoration: underline;
		color: inherit;
	}
	a:link {
		color: inherit;
	}
	a:visited {
		color: inherit;
	}
	a:hover {
		color: inherit;
	}
	a:active {
		color: inherit;
	}
`

ReactDOM.render(<App />, document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js